import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { CopyService } from '../services';

export const COPY_TOKEN: InjectionToken<CopyProvider> = new InjectionToken<CopyProvider>('COPY_TOKEN', {
  factory: (): CopyProvider => {
    const copyService: CopyService = inject(CopyService);

    return {
      copyToClipboard(value: string): Observable<void> {
        return copyService.copyToClipboard(value);
      }
    };
  }
});

export interface CopyProvider {
  copyToClipboard(value: string): Observable<void>;
}
